var map = {
	"./chat-icon-bottom-nav-mobile-active.webp": 2735,
	"./chat-icon-bottom-nav-mobile.webp": 2736,
	"./home-icon-bottom-nav-mobile-active.webp": 2737,
	"./home-icon-bottom-nav-mobile-active_b.webp": 2738,
	"./home-icon-bottom-nav-mobile.webp": 2739,
	"./home-icon-bottom-nav-mobile_b.webp": 2740,
	"./me-icon-bottom-nav-mobile-active.webp": 2741,
	"./me-icon-bottom-nav-mobile.webp": 2742,
	"./promo-icon-bottom-nav-mobile-active.webp": 2743,
	"./promo-icon-bottom-nav-mobile.webp": 2744,
	"./sponsor-icon-bottom-nav-mobile-active.webp": 2745,
	"./sponsor-icon-bottom-nav-mobile.webp": 2746,
	"./stream-icon-bottom-nav-mobile-active.webp": 2747,
	"./stream-icon-bottom-nav-mobile.webp": 2748
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2734;